// extracted by mini-css-extract-plugin
export default {"ThemeToggle":"ThemeSwitcher_ThemeToggle__bjls+"};